import React from 'react';
import { FieldTitle, useInput } from 'react-admin';
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

interface FrenchDateTimeInputProps {
    source: string;
    label?: string;
    validate?: any;
    required?: boolean;
    [key: string]: any;
}

const FrenchDateTimeInput = ({
    source,
    label,
    validate,
    required,
    ...rest
}: FrenchDateTimeInputProps) => {
    const {
        id,
        input,
        meta: { touched, error, submitError },
        isRequired,
    } = useInput({
        source,
        validate,
        isRequired: required,
    });

    const hasError = !!(touched && (error || submitError));

    return (
        <MuiPickersUtilsProvider
            utils={MomentUtils}
            locale="fr"
            libInstance={moment}
        >
            <KeyboardDateTimePicker
                id={id}
                value={input.value || null}
                onChange={(date) => {
                    input.onChange(
                        date && date.isValid()
                            ? date.toDate()
                            : null
                    );
                }}
                onBlur={input.onBlur}
                label={
                    <FieldTitle
                        label={label}
                        source={source}
                        isRequired={isRequired}
                    />
                }
                format="DD/MM/YYYY HH:mm"
                ampm={false}
                autoOk
                showTodayButton
                todayLabel="Aujourd’hui"
                cancelLabel="Annuler"
                okLabel="OK"
                invalidDateMessage="Date invalide"
                invalidLabel="Date invalide"
                error={hasError}
                helperText={hasError ? error || submitError : ' '}
                margin="dense"
                KeyboardButtonProps={{
                    'aria-label': 'Choisir la date et l’heure',
                }}
                {...rest}
            />
        </MuiPickersUtilsProvider>
    );
};

export default FrenchDateTimeInput;
